module.exports = __webpack_public_path__ + "img/img6.f53865e4.png";